import React, { useState, useEffect } from "react";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";
import useDebounce from "../../../Hook/useDebounce";
import DashboardPopOver from "../../../component/DashboardPopOver";

// Redux
import { useDispatch, useSelector } from "react-redux";
import {
  getOverviewCardDetails,
  deleteOverviewCard,
  updateOverviewCard,
} from "../../../redux/actions/overview";

function ToDoCardsGrid({
  setOpenModalPopUp,
  update,
  setUpdate,
  setOpenCardDetails,
  setCardData
}) {
  // Redux
  const dispatch = useDispatch();
  const { overviewCardData } = useSelector((state) => state.overview);

  const [cardList, setCardList] = useState([]);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [cardShuffle, setCardShuffle] = useState(0);

  // Using debouncing to get debounce version of card list
  const debounceHandleCardShuffle = useDebounce(cardShuffle, 5000);

  // Function to call update card API
  const handleCardUpdate = () => {
    const payload = cardList.map((item) => {
      return item.overview_card_id;
    });
    const request = {
      payload,
      onSuccess: () => {
        setCardShuffle(0);
      },
    };

    dispatch(updateOverviewCard(request));
  };

  useEffect(() => {
    if (debounceHandleCardShuffle) {
      handleCardUpdate();
    }
  }, [debounceHandleCardShuffle]);

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDragOver = (index) => {
    if (draggedIndex === null) return;
    if (index === cardList.length) return;
    if (index === draggedIndex) return;

    const draggedCard = cardList[draggedIndex];
    const updatedCardData = [...cardList];
    updatedCardData.splice(draggedIndex, 1);
    updatedCardData.splice(index, 0, draggedCard);

    setCardList(updatedCardData);

    setDraggedIndex(index);
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
    setCardShuffle(cardShuffle + 1);
  };

  useEffect(() => {
    const request = {
      onError: (error) => {
        swal({
          content: <CustomeModal type="error" title="Error!" content={error} />,
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getOverviewCardDetails(request));
  }, [update]);

  useEffect(() => {
    if (overviewCardData.length > 0) {
      setCardList(overviewCardData);
    }
  }, [overviewCardData]);

  // Function to call delete card API
  const handleCardDelete = (cardDetails) => {
    const request = {
      overview_card_id: cardDetails.overview_card_id,
      onSuccess: () => {
        setUpdate(update + 1);
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`Card successfully deleted.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(deleteOverviewCard(request));
  };

  return (
    <div className="grid grid-cols-6 gap-4">
      {cardList.length > 0 &&
        cardList.map((item, index) => {
          return (
            <div
              draggable
              onDragStart={() => handleDragStart(index)}
              onDragOver={() => handleDragOver(index)}
              onDragEnd={() => handleDragEnd(index)}
              className={`h-[110px] rounded-md ${
                item.status.includes("overdue")
                  ? "bg-[#FFEDED]"
                  : "bg-[--bg-color-50]"
              } p-4 cursor-pointer flex items-center relative`}
              onClick={() => {
                setCardData(item)
                setOpenCardDetails(true);
              }}
            >
              <div className="absolute top-1 right-2 text-base text-[#7D8490]">
                <DashboardPopOver
                  menus={["Delete"]}
                  handleOnClick={() =>
                    swal({
                      content: (
                        <CustomeModal
                          type="delete"
                          title="Are you sure?"
                          content="You want to delete this card."
                          onDelete={() => handleCardDelete(item)}
                        />
                      ),
                      buttons: false,
                      closeOnClickOutside: false,
                      closeOnEsc: false,
                    })
                  }
                />
              </div>
              <div className="w-full space-y-3">
                <div className="space-x-4 flex items-center">
                  <h2
                    className={`text-2xl ${
                      item.status.includes("overdue")
                        ? "text-[#EB5757]"
                        : "text-[--bg-color-500]"
                    } font-semibold leading-5`}
                  >
                    {item.count === null ? 0 : item.count}
                  </h2>
                  {item.status === "pending" ||
                  item.status === "in progress" ? (
                    <div
                      title={item.status}
                      className="border-2 border-[--bg-color-500] rounded-full h-[30px] text-[--bg-color-500] text-sm px-2 py-[2px] flex justify-center items-center capitalize w-[100px] truncate font-semibold"
                    >
                      {item.status}
                    </div>
                  ) : (
                    <div
                      title={
                        item.status === "in progress overdue"
                          ? "Overdue (In Progress)"
                          : item.status
                      }
                      className={`rounded-full h-[30px] text-[#fff] text-sm px-2 py-[2px] flex justify-center items-center capitalize ${
                        item.status === "in progress overdue"
                          ? "w-[120px]"
                          : "w-[100px]"
                      } truncate font-semibold ${
                        item.status.includes("overdue")
                          ? "bg-[#EB5757]"
                          : "bg-[--bg-color-500]"
                      }`}
                    >
                      <h2 className="w-[90%] truncate text-center">
                        {item.status === "in progress overdue"
                          ? "Overdue (In Progress)"
                          : item.status}
                      </h2>
                    </div>
                  )}
                </div>
                <h1
                  title={item.todo_name}
                  className="text-[#313439] font-semibold text-sm leading-5 w-full truncate"
                >
                  {item.todo_name}
                </h1>
              </div>
            </div>
          );
        })}
      <div
        className="h-[110px] rounded-md bg-[--bg-color-50] flex items-center p-4 cursor-pointer"
        onClick={() => setOpenModalPopUp(true)}
      >
        <div className="w-full text-center space-y-1">
          <span className="fa-regular fa-circle-plus text-[--bg-color-500]"></span>
          <h4 className="text-[13px] font-semibold text-[#9297A2] leading-5">
            Add A New Card
          </h4>
        </div>
      </div>
    </div>
  );
}

export default ToDoCardsGrid;
